import React from 'react';
import { TopIncidents } from '../../services/analyticsService';

interface Props {
  data: TopIncidents;
}

const DEFAULT_INCIDENTS = [
  { name: 'Cyberattack', count: 245, pct: 60 },
  { name: 'Power Outage', count: 189, pct: 46 },
  { name: 'Severe Weather', count: 156, pct: 38 },
  { name: 'Hardware Failure', count: 134, pct: 32 },
  { name: 'Supply Chain', count: 98, pct: 24 },
];

const TopIncidentsChart: React.FC<Props> = ({ data }) => {
  const formatIncidentType = (type: string) => {
    return type
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const rawIncidents = data?.incidents?.length ? data.incidents : null;
  const maxVal = rawIncidents ? Math.max(...rawIncidents.map((i) => i.count), 1) : 1;

  const incidents = rawIncidents
    ? rawIncidents.slice(0, 5).map((inc) => ({
        name: formatIncidentType(inc.incident_type),
        count: inc.count,
        pct: Math.min(100, Math.max(10, Math.round((inc.count / maxVal) * 65))),
      }))
    : DEFAULT_INCIDENTS;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h2 className="text-sm font-bold text-[#0c1e40] mb-4">Top 5 Incident Types</h2>
      <div className="space-y-3.5">
        {incidents.map((incident) => (
          <div key={incident.name}>
            <div className="text-xs font-semibold text-gray-800 mb-1.5">
              {incident.name}
            </div>
            <div className="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#2563eb] rounded-full transition-all duration-500"
                style={{ width: `${incident.pct}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopIncidentsChart;
